<template>
<!-- 
  <v-app>
    <v-main> -->
      <router-view />
    <!-- </v-main>
  </v-app> -->
</template>

<script>
import router from './router/index'
import SessionHelper from './utils/SessionHelper'
export default {
  name: 'App',

  components: {
  },
  mounted(){
   
          
  },
  computed:{
showSidebar(){
         return SessionHelper.checkPermission("SHOW_SIDEBAR");
      
    },
  },
  data: () => ({
    //
  })
}
</script>

